import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`A promise that is resolved when Drop-In Checkout has been properly rendered on the page, or rejected if any error occurred during initialisation.`}</p>
    <p>{`The promise is resolved with an instance of `}<a parentName="p" {...{
        "href": "/docs/sdk/web/2.x.x/primer-checkout/overview"
      }}>{`PrimerCheckout`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      